import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import defaultTheme from './defaultTheme';

function BlackBack({ open, close }) {
  const theme = useTheme();
  return (
    <div
      style={{
        backgroundColor: open ? `${theme?.colors?.primary?.textDarkGrey ?? defaultTheme.colors.primary.textDarkGrey}80` : `${theme?.colors?.primary?.textDarkGrey ?? defaultTheme.colors.primary.textDarkGrey}00`,
        pointerEvents: open ? 'all' : 'none',
        position: 'fixed',
        left: '0px',
        top: '0px',
        height: '100%',
        width: '100vw',
        zIndex: '5001',
        transition: 'background-color 325ms ease-in 0s',
      }}
      onClick={() => close()}
      onKeyDown={() => close()}
      aria-label="black-background"
      role="button"
      tabIndex="-1"
    />
  );
}

BlackBack.displayName = 'BlackBack';

export default BlackBack;

BlackBack.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
